/* global jQuery*/

export default class HandleTickets {
  constructor () {
    this.ticketForm = jQuery('form.mtt-image-program-menu__top')
    if (this.ticketForm.length === 0) {
      return
    }

    this.setupArrowsForTickets()
  }

  setupArrowsForTickets () {
    this.arrowUp = this.ticketForm.find('button.mtt-image-program-menu__count--up')
    this.arrowDown = this.ticketForm.find('button.mtt-image-program-menu__count--down')
    this.inputField = this.ticketForm.find('input[name="ticketCounter"]')
    this.maxAmount = this.inputField.attr('max')

    this.arrowUp.on('click', this.plusOne.bind(this))
    this.arrowDown.on('click', this.minusOne.bind(this))
    this.inputField.on('change', this.checkInputValue.bind(this))
  }

  plusOne (e) {
    e.preventDefault()

    let value = parseInt(this.inputField.val())
    if(value < 1) {
      value = 1
    } else if(value > this.maxAmount) {
      value = this.maxAmount
    } else {
      value++
    }

    this.inputField.val(value)
    this.inputField.trigger('change')
  }

  minusOne (e) {
    e.preventDefault()

    let value = parseInt(this.inputField.val())
    if(value > 1) {
      value--
    } else {
      value = 1
    }

    this.inputField.val(value)
    this.inputField.trigger('change')
  }

  checkInputValue (e) {
    let element = jQuery(e.currentTarget)

    if(parseInt(element.val()) <= 0) {
      element.val(1)
    }

    let aTag = this.ticketForm.find('a[data-default-url]')
    aTag.attr('href', aTag.attr('data-default-url') + element.val())
  }
}
